/**
 * Social / Creator member-facing postKind product labels (UX-04-A).
 * Mirrors travel.discover.kinds zh-TW wording; no replaceAll / raw enum chrome.
 */

export const SOCIAL_POST_KIND_PRODUCT_LABELS = Object.freeze({
  MOOD: '心情',
  JOURNEY: '旅程',
  JOURNEY_INVITATION: '旅程邀請',
  PLACE: '打卡',
  FOOD: '美食',
});

export const SOCIAL_POST_KIND_UNKNOWN_FALLBACK = '貼文';

export function socialPostKindProductLabel(kind) {
  const key = String(kind || '').trim();
  if (!key) return SOCIAL_POST_KIND_UNKNOWN_FALLBACK;
  return SOCIAL_POST_KIND_PRODUCT_LABELS[key] || SOCIAL_POST_KIND_UNKNOWN_FALLBACK;
}
